import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getProdTypeName, getPagingList } from "@/core/util";

const INIT_STATE = {
  destinationInfo: {},
  records: [],
  hasMore: true,
  needSpread: false,
};

export default function destination(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 目的地数据
    case ACTION_TYPES.GET_DESTINATION_PAGING_LIST:
      console.log("payloadpayloadpayload", payload);

      let pageTemp = {};
      if (payload?.page) {
        pageTemp = {
          ...payload?.page,
          records: payload?.page?.records && payload?.page?.records.length > 0 ? payload?.page?.records.map(item => {
            const prodTagName = getProdTypeName(item);
            const tagList = [prodTagName];
            if (item.specialityList && item.specialityList.length > 0) {
              tagList.push(item.specialityList[0]);
            }
            return {
              ...item,
              specialityListShow: tagList
            }
          }) : [],
        }
      }

      result.destinationInfo = payload || {};
      result.hasMore = judgeHasNextPage(payload?.page || {});
      result.records = getPagingList(result.records, pageTemp);

      break;
    // 点击更新产品热度数据
    case ACTION_TYPES.UPDATE_DESTINATION_HOT_DATA:
      result.records = payload;
      break;
    // 更新是否折叠
    case ACTION_TYPES.UPDATE_DESTINATION_SPREAD_DATA:
      result.needSpread = payload;
      break;
    default:
      result = state;
  }
  return result;
}